export default class InfoGroupManager {
    constructor() {
        this.eventDelegation();
    };

    eventDelegation() {
        let hotelModal = $('#groupHotel');
        let activityModal = $('#groupActivity');
        const groupGalleryTitle = document.querySelectorAll('[data-entity="title-change"]');
        if (groupGalleryTitle) {
            groupGalleryTitle.forEach((element) => {
                element.addEventListener('change-title', (e) => {
                    const currentTarget = e.currentTarget;
                    const selectorId = e.detail.id;
                    currentTarget.querySelectorAll('[data-title]').forEach((elem) => {
                        if (elem.getAttribute('data-title') !== selectorId.toString()) {
                            elem.classList.add('d-none');
                            return;
                        }

                        elem.classList.remove('d-none');
                    });
                });
            });
        }

        $('body').on("click", '[data-action="showReviewsModule"]', (event) => {
            let reviewsContainer = document.querySelector('[data-entity="reviews"]');
            let hotelModalOpen = hotelModal.find('.active-item');
            let hotelCards = document.querySelector('[data-only-option]');
            let hasOneOption;
            const activity = $(event.currentTarget).attr('data-activity');

            if (hotelCards) {
                hasOneOption = hotelCards.getAttribute('data-only-option');
            }
            if (hasOneOption === 'true' && hotelModalOpen.length === 0 && (!activity && !activityModal.hasClass('custom-modal-open'))) {
                reviewsContainer.scrollIntoView({block: "start", behavior: "smooth"});
                event.stopPropagation();
            } else if ((!hotelCards && hotelModalOpen.length === 0) && (!activity && !activityModal.hasClass('custom-modal-open'))) {
                reviewsContainer = document.getElementById('user_reviews');
                if (reviewsContainer) {
                    reviewsContainer.scrollIntoView({block: "start", behavior: "smooth"});
                    event.stopPropagation();
                }
            }
        });

        document.querySelectorAll('[data-action="load-yt-video"]').forEach(el => {
            el.addEventListener('click', () => {
                const iframe = Object.assign(document.createElement('iframe'), {
                    src: `${el.dataset.videoUrl}?autoplay=1`,
                    frameborder: '0',
                    allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
                    allowFullscreen: true,
                    className: 'yt-iframe'
                });
                el.innerHTML = '';
                el.appendChild(iframe);
            });
        });
    };
}
